import { render } from "./area-desktop.vue?vue&type=template&id=6c20bb15&scoped=true"
import script from "./area-desktop.vue?vue&type=script&lang=ts"
export * from "./area-desktop.vue?vue&type=script&lang=ts"

import "./area-desktop.vue?vue&type=style&index=0&id=6c20bb15&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-6c20bb15"

export default script